import { createSelector } from 'reselect';

export const appContentSelector = createSelector(
  (state) => state,
  (state) => state.app.content
);

export const appContentbySlugSelector = createSelector(
  (state, _) => appContentSelector(state),
  (_, filter) => filter,

  (appContent, filterString) =>
    appContent && appContent.find((item) => item.fields.slug && item.fields.slug === filterString).fields
);

export const appContentbyTypeAndSlugSelector = createSelector(
  (state, _) => appContentSelector(state),
  (state, type, slug) => type,
  (state, type, slug) => slug,

  (appContent, type, slug) =>
    appContent &&
    appContent.find(
      (item) =>
        item.fields.slug &&
        item.fields.slug === slug &&
        (item.fields.contentTypeId === type || item.sys.contentType.sys.id === type)
    )
);

export const appContentbyType = createSelector(
  (state, _) => appContentSelector(state),
  (_, type) => type,
  (appContent, type) =>
    appContent && appContent.find((item) => item.fields && item.fields.contentTypeId === type).fields
);
